import { call, put, takeEvery } from 'redux-saga/effects'
import {
  GET_TEAMS,
  ADD_TEAMS,
  UPDATE_TEAMS,
  DELETE_TEAMS,
} from './actionTypes'
import {
  getTeamsSuccess,
  getTeamsFail,
  addTeamSuccess,
  addTeamFail,
  updateTeamSuccess,
  updateTeamFail,
  deleteTeamSuccess,
  deleteTeamFail,
  setTeamFieldErrors,
} from './actions'
import axiosInstance from 'pages/Utility/axiosInstance'
import toast from 'react-hot-toast'

// API calls
const fetchTeamsApi = ({check,id}) => axiosInstance.get('', { params: { sp: 'usp_GetTeams', isAdminListing: `${check ? 1 : 0}`,solutionId:id ? id :null } })
const addTeamApi = (team) => axiosInstance.post('', team)
const updateTeamApi = (team) => axiosInstance.post('', team)
const deleteTeamApi = (id) => axiosInstance.post('', { sp: 'usp_DeleteTeam', teamId: id })

// Sagas
function* getTeamsSaga(action) {
  console.log("getTeams triggered");
  try {
    if (action.payload?.check) {
      const { data } = yield call(fetchTeamsApi, action.payload)
      yield put(getTeamsSuccess(data))
    } else {
      const { data } = yield call(fetchTeamsApi)
      yield put(getTeamsSuccess(data))
    }
  } catch (error) {
    yield put(getTeamsFail(error.response?.data || error.message))
  }
}

function* addTeamSaga(action) {
  try {
    const { data } = yield call(addTeamApi, action.payload.team)
    yield put(addTeamSuccess(data))
    toast.success('Team added successfully!');
    action.payload.onClose();
    if (action.payload.check) {
      yield put({ type: GET_TEAMS, payload: { check: action.payload.check } })
    } else {
      yield put({ type: GET_TEAMS })
    }
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setTeamFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(addTeamFail(error.response?.data || error.message))
    }
  }
}

function* updateTeamSaga(action) {
  try {
    const { data } = yield call(updateTeamApi, action.payload.team)
    yield put(updateTeamSuccess(data))
    toast.success('Team updated successfully!');
    action.payload.onClose();
    if (action.payload.check) {
      yield put({ type: GET_TEAMS, payload: { check: action.payload.check } })
    } else {
      yield put({ type: GET_TEAMS })
    }
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setTeamFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(updateTeamFail(error.response?.data || error.message))
    }
  }
}

function* deleteTeamSaga(action) {
  try {
    yield call(deleteTeamApi, action.payload.id)
    yield put(deleteTeamSuccess(action.payload))
    toast.success('Team deleted successfully!')
    if (action.payload.check) {
      yield put({ type: GET_TEAMS, payload: { check: action.payload.check } })
    } else {
      yield put({ type: GET_TEAMS })
    }
  } catch (error) {
    yield put(deleteTeamFail(error.response?.data || error.message))
  }
}

// Watcher saga
function* teamSaga() {
  yield takeEvery(GET_TEAMS, getTeamsSaga)
  yield takeEvery(ADD_TEAMS, addTeamSaga)
  yield takeEvery(UPDATE_TEAMS, updateTeamSaga)
  yield takeEvery(DELETE_TEAMS, deleteTeamSaga)
}

export default teamSaga
